import iconWithTextWebPremiumLogo from "../assets/logo-squaber-premium-134-40.png";
import iconWithTextWebStartLogo from "../assets/logo-squaber-start-134-40.png";
import iconWithTextWebProLogo from "../assets/logo-squaber-pro-134-40.png";
import iconWithTextWebInsiderLogo from "../assets/logo-squaber-insider-134-40.png";
import iconWithTextLogo from "../assets/logo-squaber-134-40-transparent.png";
import mainLogo from "../assets/squaber-icon-yellow-300-300.png";
import textLogo from "../assets/squaber-logo-text.png";

export default {
  main: mainLogo,
  text: textLogo,
  iconWithText: iconWithTextLogo,
  iconWithTextWeb: iconWithTextWebStartLogo,
  iconWithTextWebStart: iconWithTextWebStartLogo,
  iconWithTextWebPro: iconWithTextWebProLogo,
  iconWithTextWebPremium: iconWithTextWebPremiumLogo,
  iconWithTextWebInsider: iconWithTextWebInsiderLogo
};
